export const styles = () => ({
  checkboxWrapper: {
    alignItems: "center",
    display: "flex",
  },
});



// WEBPACK FOOTER //
// ./src/features/director/pages/SurveyDataCenter/components/SportCheckboxes/styles.ts